import React from 'react';

import { styled } from '@mui/material/styles';
import { ImageField } from 'react-admin';

const StyledImageField = styled(ImageField)({
    '& img': {
        maxHeight: '3rem',
        maxWidth: '9rem',
        margin: 0,
    },
});

const ThumbnailField = (props) => {
    return (
        <StyledImageField {...props} />
    );
};

export default ThumbnailField;
